import { SagaIterator } from '@redux-saga/core';
import { put, takeLatest, call, all } from 'redux-saga/effects';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';

import { isEmpty } from 'lodash';
import * as AppManagementActions from '../AppManagement/slice';
import * as Actions from './slice';
import * as Endpoints from './endpoints';
export function* updateCompanyInformation({ payload }: RequestSagaParams): SagaIterator {
  try {
    if (payload.data.logo instanceof File) {
      const mediaUploadForm = new FormData();
      mediaUploadForm.append('files', payload.data.logo);
      const logoUploadResponse = yield call(
        Endpoints.putMediaContent,
        mediaUploadForm,
        payload.marketerId,
        'companyLogo'
      );
      const logoUrl = logoUploadResponse?.data?._embedded?.assets[0]._links?.access?.href;
      const response = yield call(Endpoints.updateCompanyLogo, payload.marketerId, logoUrl);
      yield put(AppManagementActions.updateMarkerterData(response.data));
    }

    if (payload.data.cover instanceof File) {
      const mediaUploadForm = new FormData();
      mediaUploadForm.append('files', payload.data.cover);
      const coverUploadResponse = yield call(
        Endpoints.putMediaContent,
        mediaUploadForm,
        payload.marketerId,
        'companycover'
      );
      const coverUrl = coverUploadResponse?.data?._embedded?.assets[0]._links?.access?.href;
      const response = yield call(Endpoints.updateCompanyCoverImage, payload.marketerId, coverUrl);
      yield put(AppManagementActions.updateMarkerterData(response.data));
    }

    const response = yield call(Endpoints.updateCompanyWebsite, payload.marketerId, payload.data.website);
    yield put(AppManagementActions.updateMarkerterData(response.data));

    // const responsename = yield call(Endpoints.updateCompanyName, payload.marketerId, payload.data.name);
    // yield put(AppManagementActions.updateMarkerterData(responsename.data));

    yield put(Actions.updateCompanyInformationSuccess({}));

    // if (payload.callBack) {
    //   yield call(payload.callBack, response.data.uid);
    // }
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully updated the company information' });
  } catch (error: any) {
    yield put(Actions.updateCompanyInformationFailure(error));
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
  }
}

export function* updateProfileInformation({ payload }: RequestSagaParams): SagaIterator {
  try {
    if (payload.data.profile instanceof File) {
      const mediaUploadForm = new FormData();
      mediaUploadForm.append('files', payload.data.profile);
      // const logoUploadResponse = yield call(Endpoints.putMediaContent, mediaUploadForm, payload.employeeId, 'profileImage');
      // const logoUrl = logoUploadResponse?.data?._embedded?.assets[0]._links?.access?.href;
      const response = yield call(Endpoints.updateProfileImage, payload.employeeId, mediaUploadForm);
      yield put(AppManagementActions.updateProfileData(response.data));
    }

    const response = yield call(Endpoints.updateProfileName, payload.employeeId, payload.data.name);
    yield put(AppManagementActions.updateProfileData(response.data));

    // yield put(AppManagementActions.updateProfileName(response.data));

    yield put(Actions.updateProfileInformationSuccess({}));

    // if (payload.callBack) {
    //   yield call(payload.callBack, response.data.uid);
    // }
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully updated the Profile details' });
  } catch (error: any) {
    yield put(Actions.updateProfileInformationFailure(error));
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
  }
}

export function* inviteAccountSaga({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.inviteAccount, {
      emailAddress: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName
    });
    yield put(Actions.inviteAccountSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Invitation sent successfully' });
  } catch (error: any) {
    yield put(Actions.inviteAccountFailure(error?.message));
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
  }
}

export function* completeProfileSaga({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.completeProfile, {
      gender: payload.gender
    });
    yield put(Actions.completeProfileSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Profile updated successfully' });
  } catch (error: any) {
    yield put(Actions.completeProfileFailure(error?.message));
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
  }
}

export function* settingManagementWatcherSaga(): SagaIterator {
  yield all([yield takeLatest(Actions.updateCompanyInformation.type, updateCompanyInformation)]);
  yield all([yield takeLatest(Actions.updateProfileInformation.type, updateProfileInformation)]);
  yield all([yield takeLatest(Actions.completeProfile.type, completeProfileSaga)]);
  yield all([yield takeLatest(Actions.inviteAccount.type, inviteAccountSaga)]);
}

export default settingManagementWatcherSaga;
